import { action } from 'satcheljs';
import BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Action to load the booking services from the store.
 */
let loadServices = action(
    'LOAD_PBP_SERVICES',
    (services: Map<string, BookingService>, servicesOrder: string[]) => ({
        services,
        servicesOrder,
    })
);

export default loadServices;
